// @flow
import { BUTTON_TICKET } from 'Client/cms/toolkit/constants';
import { ButtonTicketLine } from 'Components/lines/button-ticket-line/ButtonTicketLine';

export const buttonTicketDescriptor = {
  name: BUTTON_TICKET,
  component: ButtonTicketLine,
};
